import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const ButtonSigningWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ButtonWrapper = styled(ButtonSigningWrapper)`
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
`

export const WaitingSigningTitle = styled.div<{ $chipColor?: string }>`
  margin-left: 15px;
  position: relative;
  font-size: 12px;
  color: ${myPalette.mutedText.main};

  &:before {
    content: '';
    width: 11px;
    height: 11px;
    background: ${({ $chipColor }) => $chipColor};
    position: absolute;
    bottom: 3px;
    left: -15px;
    border-radius: 10px;
  }
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
`

export const CreatedAt = styled.div`
  font-size: 14px;
  color: ${myPalette.mutedText.main};
`
